import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

import EFVideoPlayer from '@/components/UI/svg/mm100/Icon/EFVideoPlayer';
import EFKitH1SvgPc from '@/components/UI/svg/mm100/Icon/EFKitH1SvgPc';
import EFKitH2SvgPc from '@/components/UI/svg/mm100/Icon/EFKitH2SvgPc';
import EFKitH3SvgPc from '@/components/UI/svg/mm100/Icon/EFKitH3SvgPc';

import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ type = 'rv' }: any) {
    const { useLang, useState, useEffect, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap = {
        us: 'https://www.youtube.com/embed/jLs7VZlu-9A',
        jp: 'https://www.youtube.com/embed/Npk28ID2tI0',
        cn: {
            SD: 'https://videos.ecoflow.com/f16cc2ab3caa456a832c8bca6925bb05/17e3d1f6aee94b749529013a52f43245-9a4860f4b352b4834e2ec21cbbd5bd27-fd.mp4',
            HD: 'https://videos.ecoflow.com/f16cc2ab3caa456a832c8bca6925bb05/17e3d1f6aee94b749529013a52f43245-7852f6b282043467f020800dc0a94e65-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/15a4409a-1842c2aadfc-0004-9c91-e6d-40030.mp4',
        },
    };
    const svgList = [
        {
            svg: <EFKitH1SvgPc width="42px" height="32px" />,
            text: t('presale.product.kitH_svg_dec1'),
            textWidth: '108px',
        },
        {
            svg: <EFKitH2SvgPc width="42px" height="33px" />,
            text: t('presale.product.kitH_svg_dec2'),
            textWidth: '79px',
        },
        {
            svg: <EFKitH3SvgPc width="42px" height="32px" />,
            text: t('presale.product.kitH_svg_dec3'),
            textWidth: '98px',
        },
    ];

    const playerVideo = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Compact and Integrated Power Solution',
            position: 'Product_3',
        });
        setShowEFVideoModal(true);
    };

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.kitH`,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });

        AniContainer.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.kitH} kitH`}>
            <div className="kit-inter">
                <div className="kit-l">
                    <div className="kit-ms1">{t('presale.product.kitH_ms1')}</div>
                    <div className="kit-ms2">{t('presale.product.kitH_ms2')}</div>
                    <div className="kit-ms3">{type === 'rv' ? t('presale.product.kitH_ms3_rv') : t('presale.product.kitH_ms3_off_grid')}</div>
                    <div className="watch-video-btn" onClick={playerVideo}>
                        {t('presale.product.watch_video')}
                        <EFVideoPlayer className="icon" color="#2673ff" />
                    </div>
                    <div className="svg-box" style={{ display: locale === 'us' ? 'flex' : 'none' }}>
                        {svgList.map((item, index) => (
                            <div key={index} className="row-item">
                                <div className="svg-item">{item.svg}</div>
                                <div className="text-item" style={{ width: item.textWidth }}>
                                    {item.text}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="kit-r">
                    <div className="kit-box kit-box1">
                        {videoEnterA && <EFVideo sources={['/video/mm100m/kitH_pc_1.webm', '/video/mm100/kitH_pc_1.mp4']} className="video" />}
                        <span className="kit-video-tips">{t('presale.product.kitH_box1_tips')}</span>
                    </div>
                    <div className="kit-box kit-box2">
                        {videoEnterA && <EFVideo sources={['/video/mm100m/kitH_pc_2.webm', '/video/mm100/kitH_pc_2.mp4']} className="video" />}
                        <span className="kit-video-tips">{t('presale.product.kitH_box2_tips')}</span>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
